<script setup lang="ts">
import { LoadingView, ToastTypes, useRoute, router } from '@hfc/ui-core';
import { onBeforeMount } from 'vue';
import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';
import { useMedicareConsentStore } from '@/consent/medicare/infrastructure/composition/useMedicareConsentStore';

const { appStore } = useAppStore();
const { medicareConsentStore } = useMedicareConsentStore();

const route = useRoute();
const uuid = route.params.uuid as string;

const getMedicareConsentData = async ():Promise<void> => {
  const response = await medicareConsentStore.getMedicareConsentData(uuid);
  if (!response.success && response.error) {
    appStore.addToast({ type: ToastTypes.DANGER, message: response.error.response?.data.error as string || 'Error fetching consent data.' });
    router.push({ name: 'MedicareAppointment' });

    return;
  }

  if (response.data && response.success) {
    await medicareConsentStore.updateMedicareConsentStore({ loadingFromDb: true });
    if (!response.data.appointment_required) {
      router.push({ name: 'MedicareConsent', params: { agent: response.data.agent } });

      return;
    }

    if (response.data.aep) {
      router.push({ name: 'MedicareAppointmentAep', params: { agent: response.data.agent } });

      return;
    }

    router.push({ name: 'MedicareAppointment', params: { agent: response.data.agent } });
  }
};

onBeforeMount(() => {
  getMedicareConsentData();
});
</script>
<template>
  <div class="flex w-full h-96 justify-center items-center mt-20">
    <LoadingView class="flex w-full h-96 animate-pulse" />
  </div>
</template>
